import React from "react";
import { Box, Typography, Divider, Grid } from "@mui/material";
import { calculateAge } from "../../utility/general";

/**
 * TemplateFormalChart
 * A traditional, document-style layout emulating a formal clinical chart.
 * Uses typography and borders instead of elevated cards.
 */
export default function TemplateAlt3({ 
    reportData, 
    color, 
    letterheadUrl, 
    labName, 
    labLocation, 
    renderRow 
}) {
  const reports = reportData?.patientTestReports || [];

  return (
    <Box sx={{ p: 3, background: '#fff', maxWidth: '900px', margin: 'auto' }}>
      
      {/* 1. Main Header Grid */}
      <Grid container spacing={2} sx={{ mb: 2, alignItems: 'flex-start' }}>
        
        {/* Lab Info Column */}
        <Grid item xs={5}>
          {letterheadUrl && (
            <Box 
              component="img" 
              src={letterheadUrl} 
              alt="letterhead" 
              sx={{ width: 80, height: 80, objectFit: "contain", mb: 1 }} 
              data-letterhead="true" 
            />
          )}
          <Typography variant="h6" sx={{ color, fontWeight: 800 }}>
            {labName}
          </Typography>
          {labLocation && (
            <Typography variant="body2" sx={{ color: "#666" }}>
              {labLocation}
            </Typography>
          )}
        </Grid>

        {/* Patient & Report Info Column */}
        <Grid item xs={7}>
          <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 1.5 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              Patient: {reportData?.patientFullName || (reportData?.walkInPatient?.firstName + ' ' + reportData?.walkInPatient?.lastName) || "N/A"}
            </Typography>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" sx={{ color: '#555',mr:2 }}>
                <strong>Age:</strong> {calculateAge(reportData?.walkInPatient?.dateOfBirth)}
              </Typography>
                <Typography variant="body2" sx={{ color: '#555' }}>
                <strong>Gender:</strong> {reportData.gender || reportData?.walkInPatient?.gender  || "N/A"}
              </Typography>
              {/* Add other fields here if available, e.g., Patient ID, DOB */}
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Typography 
        variant="h4" 
        align="center" 
        sx={{ fontWeight: 700, mb: 1, letterSpacing: '1px' }}
      >
        LABORATORY REPORT
      </Typography>
      
      <Divider sx={{ mb: 3 }} />

      {/* 2. Detailed Results Section */}
      <Box>
        {reports.map((r) => (
          <Box 
            key={r.id} 
            sx={{ 
              mb: 3, 
              // Replaces Paper/shadow with a clean border
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              overflow: 'hidden' // To contain the table
            }}
          >
            <Box 
              sx={{ 
                p: 1.5, 
                background: '#f9f9f9',
                borderBottom: '1px solid #e0e0e0'
              }}
            >
              <Typography 
                variant="h6" 
                sx={{ fontWeight: 700, color: color }}
              >
                {r.internalLabService?.name}
              </Typography>
            </Box>
            
            <Box sx={{ p: 1.5 }}>
              {/* Your renderRow function is placed here */}
              {renderRow(r)}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}